// extracted by mini-css-extract-plugin
module.exports = {"section_wrapper":"AUkt6","rhs_border":"PToUF","leadplusText":"nuvwx","largefont":"Np2bY","fontBold":"Chidg","linktypeHeight":"jVNOs"};